import { render, staticRenderFns } from "./DataPointNames.vue?vue&type=template&id=7d37f21f&scoped=true"
import script from "./DataPointNames.vue?vue&type=script&lang=js"
export * from "./DataPointNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37f21f",
  null
  
)

export default component.exports